import { _defineProperty } from "./index13.js";
import { SuperMitt } from "./index229.js";
import { wrap } from "comlink";
var WorkForce = class WorkForce {
	constructor(WorkerClass, max = 1) {
		_defineProperty(this, "emitter", new SuperMitt());
		_defineProperty(this, "hardWorkers", []);
		_defineProperty(this, "_maxWorkerCount", 1);
		_defineProperty(this, "log", false);
		this.WorkerClass = WorkerClass;
		this.maxWorkerCount = max;
	}
	set maxWorkerCount(max) {
		if (max < 1) this._maxWorkerCount = Math.max(1, navigator.hardwareConcurrency + max);
		else this._maxWorkerCount = Math.min(max, navigator.hardwareConcurrency);
		const leftWorkers = this.hardWorkers.splice(this._maxWorkerCount, this.hardWorkers.length - this._maxWorkerCount);
		for (const worker of leftWorkers) worker.raw.terminate();
		this.emitter.emit("onChange");
	}
	get maxWorkerCount() {
		return this._maxWorkerCount;
	}
	async run(key, ...data) {
		return new Promise(async (resolve, reject) => {
			this.log && console.log("queueing");
			const waitForWorkerProm = this.waitForFreeWorker();
			const hardWorkerRace = await Promise.race([this.emitter.wait("stop"), waitForWorkerProm]);
			if (WorkForce.isStopEvent(hardWorkerRace)) {
				waitForWorkerProm.then((w) => {
					w.working = false;
					this.emitter.emit("onChange");
				});
				return reject(hardWorkerRace);
			}
			const hardWorker = hardWorkerRace;
			this.log && console.log("running");
			if (typeof hardWorker.comm[key] === "function") {
				const resultRace = await Promise.race([this.emitter.wait("stop"), hardWorker.comm[key](...data)]);
				if (WorkForce.isStopEvent(resultRace)) return reject(resultRace);
				const result = resultRace;
				hardWorker.working = false;
				this.emitter.emit("onChange");
				resolve(result);
			}
		});
	}
	static isStopEvent(e) {
		if (e && "workerDidStop" in e) return true;
		return false;
	}
	stop() {
		let i;
		do {
			i = this.hardWorkers.findIndex((w) => w.working);
			if (i !== -1) {
				this.hardWorkers[i].raw.terminate();
				this.hardWorkers.splice(i, 1);
			}
		} while (i !== -1);
		this.emitter.emit("stop", { workerDidStop: true });
	}
	canCreateWorker() {
		return this.hardWorkers.length < this._maxWorkerCount;
	}
	createHardWorker() {
		if (!this.canCreateWorker()) return;
		const worker = new this.WorkerClass();
		const hardWorker = {
			raw: worker,
			comm: wrap(worker)
		};
		this.hardWorkers.push(hardWorker);
		hardWorker.working = true;
		return hardWorker;
	}
	getFreeWorker() {
		const worker = this.hardWorkers.find((w) => !w.working);
		if (worker) worker.working = true;
		return worker;
	}
	async waitForFreeWorker() {
		let hardWorker;
		do {
			hardWorker = this.getFreeWorker();
			if (!hardWorker) hardWorker = this.createHardWorker();
			if (!hardWorker) await this.emitter.wait("onChange");
		} while (!hardWorker);
		return hardWorker;
	}
};
export { WorkForce };

//# sourceMappingURL=index255.js.map